import { useState, useEffect } from 'react';

import { getUserInsights } from 'api/generated/users-insight/users-insight';
import type { UserInsightDto } from 'api/generated/schemas/userInsightDto';

import { useCurrentUser } from 'hooks/api/use-current-user';

export type InsightSummary = UserInsightDto;

interface UseInsightsResult {
  loading: boolean;
  insights: InsightSummary[];
}

const useInsights = (): UseInsightsResult => {
  const [loading, setLoading] = useState<boolean>(true);
  const [insights, setInsights] = useState<InsightSummary[]>([]);
  const currentUser = useCurrentUser();

  useEffect(() => {
    const fetchInsights = async (): Promise<void> => {
      setLoading(true);
      try {
        const res = await getUserInsights(
          currentUser.data!.oktaUserId,
          Number(currentUser.data!.id),
          {
            page: 0,
            size: 100,
          }
        );

        setInsights(res ?? []);
      } catch (error) {
        console.error('An error occurred while fetching insights', error);
        setInsights([]);
      } finally {
        setLoading(false);
      }
    };

    if (currentUser?.data?.oktaUserId) {
      fetchInsights();
    }
  }, [currentUser.data]);

  return { loading, insights };
};

export default useInsights;
